import PropTypes from 'prop-types';
import React from 'react';
import MainMenuItem from 'components/core/header/MainMenuItem';
import SecurityService from 'services/SecurityService';
import ProcessUtils from 'utils/ProcessUtils';

/**
 * Renders the Logout component
 * TODO: this component will have display:none if no user is logged in
 * TODO: populate username with value obtained from the store
 */
export default class Logout extends MainMenuItem {

    handleClick(event) {
        event.preventDefault();//have to preventDefault first, otherwise if any errors occur instead of seeing them the app just reloads (nav's to home again)
        SecurityService.logout();
    }

    renderMenuComponent() {
        return (
            <a onClick={this.handleClick} id={"logout-btn"} title="Logout">
                <span><i className={"fa fa-sign-out fa-lg"} /> Logout ({ProcessUtils.getCurrentUserFullName()})</span>
            </a>
        );
    }
}

Logout.propTypes = {
    username: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/core/header/Logout.js